import { API } from "../../backend";
import axios from "axios";
import jwtDecode from "jwt-decode";

export const signup = async (user) => {
  return fetch(`${API}/user/signup`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const signin = (user) => {
  console.log(API, "API");
  return fetch(`${API}/user/login`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const verify = (user) => {
  return fetch(`${API}/user/verify`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("_access_token", JSON.stringify(data.token));
    next();
  }
};

export const isAuthenticated = () => {
  if (typeof window === "undefined") {
    return false;
  }
  if (localStorage.getItem("_access_token")) {
    return jwtDecode(localStorage.getItem("_access_token"));
  } else {
    return false;
  }
};

export const forgotPassword = (resetEmail) => {
  console.log(JSON.stringify(resetEmail));
  return fetch(`${API}/user/forgotpassword`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(resetEmail),
  })
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((err) => console.log("error happened", err));
};

export const resetPassword = (sendData, token) => {
  return fetch(`${API}/user/resetpassword/${token}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(sendData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const createCreatorForm = (form) => {
  return fetch(`${API}/creatorform/submit`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(form),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getUser = async () => {
  var config = {
    method: "get",
    url: `${API}/user/getuser`,
    headers: {
      Authorization: `Bearer ${JSON.parse(
        localStorage.getItem("_access_token")
      )}`,
    },
  };

  const res = await axios(config).catch((err) => console.log(err, "lod"));
  if (res) {
    return res.data;
  } else {
    return null;
  }
};

export const logout = (next) => {
  return fetch(`${API}/user/logout`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${JSON.parse(
        localStorage.getItem("_access_token")
      )}`,
    },
  })
    .then((response) => {
      console.log(response.json());
      localStorage.removeItem("_access_token");
    })
    .catch((err) => console.log(err));
};

export const getCreator = async () => {
  var config = {
    method: "get",
    url: `${API}/creator/get`,
    headers: {
      Authorization: `Bearer ${JSON.parse(
        localStorage.getItem("_access_token")
      )}`,
    },
  };

  const res = await axios(config);

  return res.data;
};
export const resendOtp = (email) => {
  console.log(JSON.stringify(email));
  return fetch(`${API}/user/requestotp`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(email),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log("error happened", err));
};
